import { styled } from "@mui/material/styles";
import { GREEN_LOGO } from "../../theme/colors";
import { TableContainer } from "@mui/material";

export const CustomTableContainer = styled(TableContainer)(({ theme }) => ({
    // Base scrollbar styling
    "&::-webkit-scrollbar": {
      height: "8px", // Height for horizontal scrollbar
      width: "8px", // Width for vertical scrollbar
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: theme.palette.mode === "light" ? "#f1f1f1" : "#2d2d2d",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
    // This is the key part - remove ALL scrollbar buttons/arrows
    "&::-webkit-scrollbar-button": {
      display: "none !important",
      width: "0px",
      height: "0px",
    },
    // For Firefox
    scrollbarWidth: "thin",
    scrollbarColor: `${GREEN_LOGO} ${theme.palette.mode === "light" ? "#f1f1f1" : "#2d2d2d"}`,
    // For IE and Edge
    msOverflowStyle: "none",
  
    // Ensure horizontal scrolling is enabled
    overflowX: "auto",
    maxWidth: "100%",
  }))